import { Type } from '@sinclair/typebox';
import { match } from 'ts-pattern';
export var SupportedDex;
(function (SupportedDex) {
    SupportedDex["DelugeVLMM"] = "deluge-vlmm";
    SupportedDex["RaydiumV4"] = "raydium-v4";
    SupportedDex["RaydiumCPMM"] = "raydium-cpmm";
    SupportedDex["RaydiumCLMM"] = "raydium-clmm";
    SupportedDex["RaydiumLaunchpad"] = "raydium-launchpad";
    SupportedDex["BonkFun"] = "bonk-fun";
    SupportedDex["MeteoraDyn"] = "meteora-dyn";
    SupportedDex["MeteoraDlmm"] = "meteora-dlmm";
    SupportedDex["PumpFun"] = "pump-fun";
    SupportedDex["PumpSwap"] = "pump-swap";
    SupportedDex["Jupiter"] = "jupiter";
    SupportedDex["PancakeSwapV1"] = "pancakeswap-v1";
    SupportedDex["PancakeSwapV2"] = "pancakeswap-v2";
    SupportedDex["PancakeSwapV3"] = "pancakeswap-v3";
    SupportedDex["UniswapV2"] = "uniswap-v2";
    SupportedDex["UniswapV3"] = "uniswap-v3";
    SupportedDex["Orca"] = "orca";
    SupportedDex["DeDust"] = "dedust";
    SupportedDex["StonFiV1"] = "stonfi-v1";
    SupportedDex["StonFiV2"] = "stonfi-v2";
})(SupportedDex || (SupportedDex = {}));
export const SupportedDexSchema = Type.Enum(SupportedDex);
export const parseSupportedDex = (dex) => match(dex)
    .with('deluge-vlmm', () => SupportedDex.DelugeVLMM)
    .with('raydium-v4', () => SupportedDex.RaydiumV4)
    .with('raydium-cpmm', () => SupportedDex.RaydiumCPMM)
    .with('raydium-clmm', () => SupportedDex.RaydiumCLMM)
    .with('raydium-launchpad', () => SupportedDex.RaydiumLaunchpad)
    .with('bonk-fun', () => SupportedDex.BonkFun)
    .with('meteora-dyn', () => SupportedDex.MeteoraDyn)
    .with('meteora-dlmm', () => SupportedDex.MeteoraDlmm)
    .with('pump-fun', () => SupportedDex.PumpFun)
    .with('pump-swap', () => SupportedDex.PumpSwap)
    .with('jupiter', () => SupportedDex.Jupiter)
    .with('uniswap-v2', () => SupportedDex.UniswapV2)
    .with('uniswap-v3', () => SupportedDex.UniswapV3)
    .with('pancakeswap-v1', () => SupportedDex.PancakeSwapV1)
    .with('pancakeswap-v2', () => SupportedDex.PancakeSwapV2)
    .with('pancakeswap-v3', () => SupportedDex.PancakeSwapV3)
    .with('orca', () => SupportedDex.Orca)
    .with('dedust', () => SupportedDex.DeDust)
    .with('stonfi-v1', () => SupportedDex.StonFiV1)
    .with('stonfi-v2', () => SupportedDex.StonFiV2)
    .otherwise(() => {
    throw new Error(`Unsupported dex: ${dex}`);
});
//# sourceMappingURL=supported-dex.js.map